export default __webpack_public_path__ + "static/BNCFF_Showcase_banner_mobile-e22d4eed74e539a4f6246e40afc71f3c.jpg";